import * as yup from 'yup';
import type { Network } from '../../../types/shared';
import { MULTIPLE_FILTER_OPERATORS } from '../constants';

const facebookValue = yup
  .string()
  .label("Can't be empty")
  .when('operator', {
    is: (operator: string) => MULTIPLE_FILTER_OPERATORS.includes(operator),
    then: () => yup.array(yup.string()).min(1),
    otherwise: () => yup.string().required('Value is required').min(1),
  });

const googleValue = yup.string().label("Can't be empty").required('Value is required');

const filterItemSchema = yup.object().shape({
  field: yup.string().required().min(1).label("Can't be empty"),
  operator: yup.string().required().min(1).label("Can't be empty"),
  value: yup.lazy((value, options) => {
    const network = options.context?.network as Network;
    if (network === 'facebook') {
      return facebookValue;
    }

    if (network === 'google') {
      return googleValue;
    }

    return yup.string().test('alwaysError', function () {
      return this.createError({ message: 'Invalid network' });
    });
  }),
});

const filtersArraySchema = yup.array().of(filterItemSchema).min(1);

const filtersGroupArrayValidationSchema = yup.array().of(filtersArraySchema).min(1);

export default filtersGroupArrayValidationSchema;
